import React from 'react';
import amzLogo from '../../../../../public/platform/amazon.svg';
import shopifyLogo from '../../../../../public/platform/shopify.svg';
import walmartLogo from '../../../../../public/platform/walmart.svg';
import wixLogo from '../../../../../public/platform/wix.svg';
import ebayLogo from '../../../../../public/platform/ebay.svg';
import otherLogo from '../../../../../public/platform/other.svg';
import magnetoLogo from '../../../../../public/platform/magento.svg';
import bigCommerceLogo from '../../../../../public/platform/bigCommerce.svg';
import squareSpaceLogo from '../../../../../public/platform/squarespace.svg';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  platformLogo: { width: '100%' },
}));

function generateLogoImg(src: string, style: string) {
  return <img src={src} alt="" className={style} />;
}

export function useGetPlatformQuestions(urlParams: URLSearchParams) {
  const classes = useStyles();
  const style = classes.platformLogo;

  const questions = {
    amazon: {
      id: 'amazon',
      text: generateLogoImg(amzLogo, style),
      dataAutomationId: 'amazon',
    },
    shopify: {
      id: 'shopify',
      text: generateLogoImg(shopifyLogo, style),
      dataAutomationId: 'shopify',
    },
    walmart: {
      id: 'walmart',
      text: generateLogoImg(walmartLogo, style),
      dataAutomationId: 'walmart',
    },
    wix: {
      id: 'wix',
      name: 'Wix',
      text: generateLogoImg(wixLogo, style),
      dataAutomationId: 'wix',
    },
    ebay: {
      id: 'ebay',
      name: 'Ebay',
      text: generateLogoImg(ebayLogo, style),
      dataAutomationId: 'ebay',
    },
    other: {
      id: 'other',
      name: 'other',
      text: generateLogoImg(otherLogo, style),
      dataAutomationId: 'other',
    },
  };

  const utm_campaign = urlParams.get('utm_campaign');
  if (utm_campaign) {
    if (utm_campaign.includes('magento')) {
      questions['magento'] = {
        id: 'magento',
        text: generateLogoImg(magnetoLogo, style),
        dataAutomationId: 'magento',
      };
      delete questions.other;
    } else if (utm_campaign.includes('bigcommerce')) {
      questions['bigCommerce'] = {
        id: 'bigCommerce',
        text: generateLogoImg(bigCommerceLogo, style),
        dataAutomationId: 'bigCommerce',
      };
      delete questions.other;
    } else if (utm_campaign.includes('squarespace')) {
      questions['squarespace'] = {
        id: 'squarespace',
        text: generateLogoImg(squareSpaceLogo, style),
        dataAutomationId: 'squarespace',
      };
      delete questions.other;
    }
  }

  return questions;
}
